import { Snackbar, Alert, Slide } from '@mui/material'

const SlideTransition = (props) => <Slide {...props} direction='down' />

const Toast = ({ toast, onClose }) => {
  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={SlideTransition}
    >
      <Alert
        severity={toast.severity}
        variant='filled'
        onClose={onClose}
        sx={{ minWidth: 300, fontSize: '14px', whiteSpace: 'pre-line' }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  )
}

export default Toast
